module.exports = __webpack_public_path__ + "static/media/bird_pillow.cf6dbdfc.jpg";